import React, { createContext, FC, useCallback, useContext, useState } from "react";
import Snackbar, { SnackbarMessageType } from "../components/Snackbar";

interface SnackbarContextProps {
  showSnackbarMessage: (message: string, messageType: SnackbarMessageType) => void;
}
const SnackbarContext = createContext<SnackbarContextProps | undefined>(undefined);

interface SnackbarContextProviderProps extends React.PropsWithChildren {
  dismissTimeout?: number;
}
const SnackbarContextProvider: FC<SnackbarContextProviderProps> = ({
  children,
  dismissTimeout = 10000,
}) => {
  const [snackbar, setSnackbar] = useState<{
    message: string;
    messageType: SnackbarMessageType;
  }>();

  const showSnackbarMessage = useCallback((message: string, messageType: SnackbarMessageType) => {
    setSnackbar({ message, messageType });
  }, []);

  const onSnackbarDismiss = () => {
    setSnackbar(undefined);
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbarMessage }}>
      {snackbar && (
        <Snackbar
          showMessage={!!snackbar.message}
          message={snackbar.message}
          messageType={snackbar.messageType}
          dismissTimeout={dismissTimeout}
          onSnackbarDismiss={onSnackbarDismiss}
        />
      )}
      {children}
    </SnackbarContext.Provider>
  );
};

const useSnackbarContext = () => {
  const snackbarContext = useContext(SnackbarContext);
  if (!snackbarContext) {
    throw Error("Snackbar context is not initialized");
  }
  return snackbarContext;
};

export { SnackbarContext, useSnackbarContext };

export default SnackbarContextProvider;
